function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { connect } from 'react-redux';
export const withConditionalRendering = (Component, condition) => {
  const WrappedComponent = _ref => {
    let {
        shouldDisplay
      } = _ref,
      props = _objectWithoutProperties(_ref, ["shouldDisplay"]);
    if (!shouldDisplay) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Component, props);
  };
  const mapStateToProps = state => ({
    shouldDisplay: condition(state)
  });
  return connect(mapStateToProps)(WrappedComponent);
};